import { Stack, Typography } from "@mui/material";
import { FlagIcon, FlagIconCode } from "react-flag-kit";

import { numberWithCommas } from "@/utils";
import { COUNTRIES } from "@/constants";

export const columns: IColumn<PotentialCountry>[] = [
  {
    name: "Country Name",
    key: "countryOfOriginCode",
    align: "left",
    width: "300px",
    component: ({ countryOfOriginCode }) => {
      return (
        <Stack direction="row" gap={1.25} alignItems="center">
          {COUNTRIES.find(
            (singleCountry) => singleCountry.shortForm === countryOfOriginCode
          )?.name ? (
            <FlagIcon
              style={{ borderRadius: "50px" }}
              code={countryOfOriginCode as FlagIconCode}
            />
          ) : null}
          <Typography variant="body2" whiteSpace="nowrap">
            {COUNTRIES.find(
              (singleCountry) => singleCountry.shortForm === countryOfOriginCode
            )?.name ?? countryOfOriginCode}
          </Typography>
        </Stack>
      );
    },
  },
  {
    name: "Trade Agreement Opportunity",
    key: "potentialSaving",
    align: "right",
    width: "120px",
    component: ({ potentialSaving }) => numberWithCommas(potentialSaving),
  },
];
